import Footer from "../components/Footer/Footer"
import FixedImageSection from "../components/Home/FixedImageSection"
import Hero from "../components/Home/Hero"
import MoreAboutUs from "../components/Home/MoreAboutUs"

import SpecialOffer from "../components/Home/SpecialOffer"
import Testimonial from "../components/Home/Testimonial"
import Whatwedo from "../components/Home/Whatwedo"
import Navbar from "../components/Navbar/Navbar"


const Homepage = () => {
    return (
        <div>
            <Navbar />
            <Hero />
            <MoreAboutUs />

            <Whatwedo />
            <FixedImageSection />

            <Testimonial />
            <SpecialOffer/>

            <Footer/>


        </div>
    )
}

export default Homepage